import { useAuth } from "@/lib/auth.jsx";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, FESTIVAL_META, resolveMediaUrl } from "@/lib/api";

export default function Landing() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { data: festData } = useQuery({ queryKey: ["festivals-public"], queryFn: () => api.get("/festivals").then(r => r.data), retry: 0 });
  const shortName = festData?.season?.short_name || "FM27";
  const seasonName = festData?.season?.name || "Festivalmanager 2027";

  useEffect(() => {
    if (!loading && user) navigate("/hjem", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/hjem";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24 lg:pt-28 lg:pb-32">
          <div className="flex items-baseline gap-3">
            <span className="font-score text-3xl">{shortName}</span>
            <span className="label-eyebrow">{seasonName} · Danmarks festivaler</span>
          </div>
          <h1 className="hero-title mt-8 text-5xl sm:text-6xl lg:text-8xl max-w-4xl">
            Forudsig næste års<br/>
            <span style={{ color: "#FF4500" }}>festival</span>-lineup.
          </h1>
          <p className="mt-8 text-lg text-zinc-400 max-w-2xl font-body">
            Fantasy-lineup for de fem største danske festivaler. Vælg dine artister før programmerne annonceres.
            Få point når du rammer, og konkurrer mod dine venner.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Button
              onClick={login}
              data-testid="landing-google-login-btn"
              size="lg"
              className="bg-white text-black hover:bg-zinc-200 rounded-full px-8 py-6 text-base font-semibold"
            >
              Log ind med Google
            </Button>
            <Link to="/regler" data-testid="landing-rules-btn">
              <Button size="lg" variant="outline" className="rounded-full px-8 py-6 text-base font-semibold border-white/20 text-white hover:bg-white/5">
                Se reglerne
              </Button>
            </Link>
            <div className="text-sm text-zinc-500">Deadline: <span className="text-zinc-200 font-semibold">1. oktober 2026</span></div>
          </div>

          {/* Festival marquee */}
          <div className="mt-20 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
            {(festData?.festivals?.length ? festData.festivals : Object.entries(FESTIVAL_META).map(([id, f]) => ({ id, name: f.name, image_url: null }))).map(f => {
              const meta = FESTIVAL_META[f.id] || {};
              const imgSrc = resolveMediaUrl(f.image_url) || meta.image;
              const color = meta.color || f.color || "#FFFFFF";
              const glow = meta.glow || "";
              return (
                <div key={f.id} className={`card-flat overflow-hidden ${glow} interactive`}>
                  <div className="aspect-[3/4] relative">
                    <img src={imgSrc} alt={f.name} className="absolute inset-0 w-full h-full object-cover opacity-70" />
                    <div className="absolute inset-0" style={{ background: `linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.85) 100%)` }} />
                    <div className="absolute inset-x-0 bottom-0 p-4">
                      <div className="h-1 w-8 mb-3" style={{ background: color }} />
                      <div className="font-display font-bold text-lg leading-tight">{f.name}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
